<template>
	<div>
		<div style="position: relative;">
			<router-view></router-view>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'App',
		data(){
			return {
				
			}
		},
		methods:{
			
			
		},
		mounted() {
		  // 获取 DOM 元素
			
		}
	}
</script>

<style>
	.van-circle__text{
		color: #fff !important;
	}
	:root {
	    --primary-bg-color: #e0e1ee;
	    --second-bg-color: rgb(251, 251, 250);
	    --primary-txt-color: #333;
	    --second-txt-color: #999;
	    --color-primary: #8853F8;
	    --color-primary-second: #787DF4;
	    --color-blue: #00a862;
	    --color-primary-transparent: #8853F820;
	    --color-white: #fff;
	    --bg-gray: #f5f5f5;
	    --color-title: #262626;
	    --color-subTitle: #7A859B;
	    --color-secTitle: #4d5157;
	    --color-danger: #ff4d4f;
	    --color-warning: rgb(250, 173, 20);
	    --color-success: rgb(82, 196, 26);
	    --color-forbid: rgba(0, 0, 0, .45);
	    --color-light-bg: #f5f5fd;
	    --color-light-bg2: rgba(1, 197, 177, .04);
	    --border-color: #ddd;
	    --antd-border-color: #d9d9d9;
	    --color-bg-button: #9599F7;
	    --light-txt-color: #666;
	    --second-light-txt-color: #999;
	    --publish-light-color-1: #CACACA;
	    --publish-light-color-2: #e1e1e1;
	    --type-setting-border-color: rgba(151, 151, 151, .55);
	    --type-setting-text-color: #6C6969;
	    --type-setting-other-color-1: #d7d7e6;
	    --type-setting-other-color-2: rgba(0, 6, 185, .15);
	    --type-setting-other-color-3: rgba(79, 85, 238, .58);
	    --type-setting-other-color-4: #3e3e3ec0;
	    --color-transparent: #ffffff00;
	    --data-analyse-other-color-1: #cdcde4;
	    --data-analyse-other-color-2: #fafafa
	}
	
	::-webkit-scrollbar {
	    width: 3px;
	    height: 8px;
	    background-color: transparent
	}
	
	::-webkit-scrollbar-thumb {
	    background-color: #9093994d;
	    border-radius: 5px
	}

	*{
		margin: 0;
		padding: 0;
		
	}
	
	
</style>
